<template>
  <div class="grid grid-cols-12 gap-6">
    <div class="col-span-12 2xl:col-span-9">
      <div class="grid grid-cols-12 gap-6">
        <!-- BEGIN: Weekly Top Products -->
        <div class="col-span-12 mt-6">
          <div class="intro-y block sm:flex items-center h-10">
            <h2 class="text-lg font-medium truncate mr-5">
              {{ $t('reservation.list') }}
            </h2>
            <div class="flex items-center sm:ml-auto mt-3 sm:mt-0">
              <a
                @click="reloadData"
                class="ml-auto flex items-center text-theme-1 dark:text-theme-10"
              >
                <RefreshCcwIcon class="w-4 h-4 mr-3" />
                {{ $t('reservation.reload') }}
              </a>
            </div>
          </div>
          <div
            class="intro-y overflow-auto box lg:overflow-visible mt-8 sm:mt-0"
          >
            <Calendar ref="reservationCalendar" />
          </div>
          <!-- END: Weekly Top Products -->
        </div>
      </div>
    </div>
    <div class="col-span-12 2xl:col-span-3">
      <div class="2xl:border-l border-theme-5 -mb-10 pb-10">
        <div class="2xl:pl-6 grid grid-cols-12 gap-6">
          <!-- BEGIN: Transactions -->
          <div
            class="col-span-12 md:col-span-6 xl:col-span-4 2xl:col-span-12 mt-3 2xl:mt-8"
          >
            <div class="intro-x flex items-center h-10">
              <h2 class="text-lg font-medium truncate mr-5">
                {{ $t('provider.stats.name') }}
              </h2>
            </div>
            <div class="mt-5" v-show="loading">
              <LoadingIcon icon="three-dots" class="w-8 h-8" />
            </div>
            <div class="mt-5" v-show="!loading">
              <div class="col-span-12 sm:col-span-6 xl:col-span-3 intro-y">
                <div class="report-box zoom-in">
                  <div class="box p-5">
                    <div class="flex">
                      <CalendarIcon class="report-box__icon text-theme-10" />
                      <div class="ml-auto"></div>
                    </div>
                    <div class="text-3xl font-medium leading-8 mt-6">
                      {{ this.stats.activeReservations }}
                    </div>
                    <div class="text-base text-gray-600 mt-1">
                      {{ $t('provider.stats.activeReservations') }}
                    </div>
                  </div>
                </div>
              </div>
              <br /><br />
              <div class="col-span-12 sm:col-span-6 xl:col-span-3 intro-y">
                <div class="report-box zoom-in">
                  <div class="box p-5">
                    <div class="flex">
                      <MapPinIcon class="report-box__icon text-theme-10" />
                      <div class="ml-auto"></div>
                    </div>
                    <div class="text-3xl font-medium leading-8 mt-6">
                      {{ this.stats.activeBranches }}
                    </div>
                    <div class="text-base text-gray-600 mt-1">
                      {{ $t('provider.stats.activeBranches') }}
                    </div>
                  </div>
                </div>
              </div>
              <br /><br />
              <div class="col-span-12 sm:col-span-6 xl:col-span-3 intro-y">
                <div class="report-box zoom-in">
                  <div class="box p-5">
                    <div class="flex">
                      <BookmarkIcon class="report-box__icon text-theme-10" />
                      <div class="ml-auto"></div>
                    </div>
                    <div class="text-3xl font-medium leading-8 mt-6">
                      {{ this.stats.activeServices }}
                    </div>
                    <div class="text-base text-gray-600 mt-1">
                      {{ $t('provider.stats.activeServices') }}
                    </div>
                  </div>
                </div>
              </div>
              <br /><br />
              <div class="col-span-12 sm:col-span-6 xl:col-span-3 intro-y">
                <div class="report-box zoom-in">
                  <div class="box p-5">
                    <div class="flex">
                      <BoxIcon class="report-box__icon text-theme-10" />
                      <div class="ml-auto"></div>
                    </div>
                    <div class="text-3xl font-medium leading-8 mt-6">
                      {{ this.stats.activeResources }}
                    </div>
                    <div class="text-base text-gray-600 mt-1">
                      {{ $t('provider.stats.activeResources') }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- END: Transactions -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, ref } from 'vue'
import Calendar from '../../components/reservations/Calendar.vue'
import providerApi from '../../services/providers/provider.api'

export default defineComponent({
  components: {
    Calendar
  },
  computed: {
    console: () => console
  },
  data() {
    return {
      stats: {
        activeReservations: 0,
        activeBranches: 0,
        activeServices: 0,
        activeResources: 0
      }
    }
  },
  methods: {
    reloadData() {
      this.$refs.reservationCalendar.reloadCalendar()
    }
  },
  mounted() {
    providerApi.getStats().then(
      response => {
        this.stats = response.data
        this.loading = false
      },
      error => {
        console.log(error)
        this.loading = false
      }
    )
  },
  setup() {
    const loading = ref(true)

    return {
      loading
    }
  }
})
</script>
